<template>
  <Modal v-model="reasonForRejectionModal" :title="$t('key1000603')" width="550"
    :mask-closable="false" @on-visible-change="reasonForRejectionChange">
    <Input v-model.trim="rejectText" type="textarea" :rows="6"></Input>
    <template #footer>
      <Button @click="reasonForRejectionModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="reasonForRejectionBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'reasonForRejectionModal',
  mixins: [Mixin],
  data() {
    return {
      reasonForRejectionModal: false,
      rejectText: '',
      ymsProductInfoTemplateIds: [],
      reviewType: null,
    };
  },
  methods: {
    // 初始化数据
    initReasonForRejectionData(ymsProductInfoTemplateIds, reviewType) {
      this.reviewType = reviewType;
      this.ymsProductInfoTemplateIds = ymsProductInfoTemplateIds;
      this.reasonForRejectionModal = true;
    },
    // 确定
    reasonForRejectionBtn() {
      let query = {
        shelvedRejectReason: this.rejectText,
        ymsProductInfoTemplateIds: this.ymsProductInfoTemplateIds
      };
      this.axios.put(api.put_ymsProductInfoTemplate_batchRejected, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          this.reasonForRejectionModal = false;
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          switch (this.reviewType) {
            case 'newProductReview':
              this.$route.path !== '/newProductReviewList' ? this.$router.push('/newProductReviewList') : this.$emit('updateData', true);
              break;
            case 'onSaleReview':
              this.$route.path !== '/productReviewForSaleList' ? this.$router.push('/productReviewForSaleList') : this.$emit('updateData', true);
              break;
          }
        }
      });
    },
    // 监听弹窗
    reasonForRejectionChange(value) {
      if (!value) {
        this.rejectText = '';
        this.ymsProductInfoTemplateIds = [];
        this.reviewType = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
